
export const dedupLock = (
    <svg
        width="826px"
        height="249px"
        viewBox="0 0 826 249"
        version="1.1"
    >
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="1280-copy-20"
                transform="translate(-392.000000, -954.000000)"
            >
                <g
                    id="Group-11"
                    transform="translate(392.000000, 954.000000)"
                >
                    <g id="Group-12">
                        <g id="Group-10">
                            <rect
                                id="Rectangle-Copy-12"
                                fill="#FFFFFF"
                                x="0"
                                y="0"
                                width="826"
                                height="249"
                            ></rect>
                            <g
                                id="Group-9"
                                transform="translate(14.000000, 28.000000)"
                            >
                                <g
                                    id="3-rows-chart"
                                    transform="translate(0.000000, 48.000000)"
                                    fill="#D4D8DC"
                                >
                                    <g
                                        id="0-line"
                                        transform="translate(0.000000, 144.000000)"
                                    >
                                        <polygon
                                            id="y-line"
                                            points="0.00451467269 1 0.00451467269 0 798.004515 0 798.004515 1"
                                        ></polygon>
                                    </g>
                                    <g
                                        id="1st-line"
                                        transform="translate(0.000000, 72.000000)"
                                    >
                                        <polygon
                                            id="y-line"
                                            points="0.00451467269 1 0.00451467269 0 798.004515 0 798.004515 1"
                                        ></polygon>
                                    </g>
                                    <g id="2nd-line">
                                        <polygon
                                            id="y-line"
                                            points="0.00451467269 1 0.00451467269 0 798.004515 0 798.004515 1"
                                        ></polygon>
                                    </g>
                                </g>
                                <g
                                    id="Group-7"
                                    transform="translate(5.000000, 0.000000)"
                                >
                                    <rect
                                        id="Rectangle"
                                        fill="#4F8DFA"
                                        x="0"
                                        y="0"
                                        width="60"
                                        height="193"
                                    ></rect>
                                    <rect
                                        id="Rectangle"
                                        fill="#8DD2FF"
                                        x="0"
                                        y="27"
                                        width="60"
                                        height="133"
                                    ></rect>
                                    <rect
                                        id="Rectangle"
                                        fill="#FF9A47"
                                        x="0"
                                        y="0"
                                        width="60"
                                        height="28"
                                    ></rect>
                                </g>
                                <g
                                    id="Group-6"
                                    transform="translate(341.000000, 27.000000)"
                                >
                                    <rect
                                        id="Rectangle-Copy-3"
                                        fill="#4F8DFA"
                                        x="0"
                                        y="0"
                                        width="60"
                                        height="166"
                                    ></rect>
                                    <rect
                                        id="Rectangle-Copy-4"
                                        fill="#8DD2FF"
                                        x="0"
                                        y="57"
                                        width="60"
                                        height="76"
                                    ></rect>
                                    <rect
                                        id="Rectangle-Copy-5"
                                        fill="#FF9A47"
                                        x="0"
                                        y="0"
                                        width="60"
                                        height="58"
                                    ></rect>
                                </g>
                                <g
                                    id="Group-5"
                                    transform="translate(673.000000, 41.000000)"
                                >
                                    <rect
                                        id="Rectangle-Copy-6"
                                        fill="#4F8DFA"
                                        x="0"
                                        y="0"
                                        width="60"
                                        height="152"
                                    ></rect>
                                    <rect
                                        id="Rectangle-Copy-7"
                                        fill="#8DD2FF"
                                        x="0"
                                        y="59"
                                        width="60"
                                        height="36"
                                    ></rect>
                                    <rect
                                        id="Rectangle-Copy-8"
                                        fill="#FF9A47"
                                        x="0"
                                        y="0"
                                        width="60"
                                        height="59"
                                    ></rect>
                                </g>
                            </g>
                        </g>
                        <rect
                            id="Rectangle"
                            fillOpacity="0.6"
                            fill="#FFFFFF"
                            x="0"
                            y="0"
                            width="826"
                            height="249"
                        ></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
